// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"data-error"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V12H3V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 12H3M21 12V13.5M21 12V3H3V12M3 12L3 21.0004H13.5M3 12V11.998M6.99805 16.5H7.00195V16.5039H6.99805V16.5ZM6.99805 7.5H7.00195V7.50391H6.99805V7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.6215 17.3789L19.5002 19.5002M19.5002 19.5002L17.3789 21.6215M19.5002 19.5002L17.3789 17.3789M19.5002 19.5002L21.6215 21.6215","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DataErrorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'data-error',
    ref,
    icon: element,
  },
));

DataErrorIcon.displayName = 'DataErrorIcon';

export default DataErrorIcon;
